export const catalog = {
    playlistTitleMaxLength: 100
};
